import { render, staticRenderFns } from "./MonthAllowancesPlanEdit.vue?vue&type=template&id=4b5b8ea8&scoped=true&"
import script from "./MonthAllowancesPlanEdit.vue?vue&type=script&lang=js&"
export * from "./MonthAllowancesPlanEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5b8ea8",
  null
  
)

export default component.exports